<script setup lang="ts">
/**
 * Тип задачи — макет 5:12: квадрат 16 со скруглением 4, залитый цветом типа,
 * внутри белый глиф.
 *
 * Глифы, а не иконки lucide: на шестнадцати пикселях штриховая иконка
 * превращается в кляксу, а залитый квадрат с одним знаком читается и на
 * половине экрана карточек. Имя типа уходит в `title` — глиф сам по себе
 * ничего не говорит тому, кто видит доску впервые.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { V1IssueType } from '@/api/clients/tracker-issue'

import { typeColor, typeGlyph } from '../visuals'

const props = defineProps<{ type: V1IssueType | '' }>()

const { t, te } = useI18n()

const label = computed(() =>
  props.type && te(`issues.types.${props.type}`) ? t(`issues.types.${props.type}`) : '',
)
</script>

<template>
  <span class="itype" :style="{ background: typeColor(type) }" :title="label">
    <span aria-hidden="true">{{ typeGlyph(type) }}</span>
    <span class="itype__label">{{ label }}</span>
  </span>
</template>

<style scoped>
.itype {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* 16 и 4 из макета: шкала радиусов начинается с восьми, а здесь квадратик. */
  width: 16px;
  height: 16px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 9px;
  font-weight: var(--font-weight-bold);
  line-height: 1;
}

/* Имя типа читает скринридер: `title` он не всегда произносит. */
.itype__label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
</style>
